module.exports = __webpack_public_path__ + "img/fc5d22292336ddc45a74a42690a103a8.ad2202b0.png";